import {TopListHeaderProps} from './types'
import * as React from 'react'
import {ChangeEvent, useEffect, useState} from 'react'
import {InputSelectOption, InputSelectTheme} from '@sharedComponents/InputSelect/types'
import {isBrowser} from '@apps/Shared/Utils'
import {useTranslation} from 'react-i18next'
import Icon from '../../Shared/Components/Icon'
import InputSelect from '../../Shared/Components/InputSelect'
import InputSearch from '../../Shared/Components/InputSearch'
import './Scss/top-list-header.scss'
import {County} from "@apps/Shared/Types/County";

const TopListHeader = (props: TopListHeaderProps) => {
    const { t } = useTranslation()
    const [search, setSearch] = useState<string>('')
    const [autoCompleteValue, setAutoCompleteValue] = useState<string>('off')
    const [county, setCounty] = useState<InputSelectOption | undefined>()
    const [countyOptions, setCountyOptions] = useState<InputSelectOption[]>([])
    const [year, setYear] = useState<InputSelectOption | undefined>()
    const [yearOptions, setYearOptions] = useState<InputSelectOption[]>([])

    const initCountySelectOtions = () => {
        const counties: any[] = []
        //Get stringvalues from enum and add to array
        for (const value of enumKeys(County)) {
            if (County[value] === props.initialCounty) {
                const initCounty = {
                    value: value,
                    label: County[value],
                }
                setCounty(initCounty)
            }
            counties.push({
                value: value,
                label: County[value],
            })
        }

        //sort alphabetically but make sure enum "All" is on top.
        const allCounties = counties.shift()
        counties.sort((a, b) => a.label.localeCompare(b.label))
        counties.unshift(allCounties!)
        setCountyOptions(counties)
    }

    const initYearOtions = () => {
        const currentYear = new Date().getFullYear().toString()
        setYear({ value: currentYear, label: currentYear })

        const listYears: any[] = []
        let listYear = new Date().getFullYear()
        while (listYear >= 2020) {
            listYears.push({
                value: listYear.toString(),
                label: listYear.toString(),
            })
            listYear = listYear - 1
        }
        setYearOptions(listYears)
    }

    const onChangeYear = (option: InputSelectOption) => {
        const value = option.value
        setYear(option)
        props.onYearChange(value)
    }

    const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setSearch(value)
        props.onSearch(value)
    }

    const onChangeCounty = (option: InputSelectOption) => {
        const value = option.value
        setCounty(option)
        props.onCountyChange((County as any)[value]);
    }

    useEffect(() => {
        if (isBrowser) {
            const inputsOnPage = document.querySelectorAll('input')?.length || 0
            // Site searchinput + this input = 2.
            // If there are more fields, we need this piece of magic to turn off autocomplete.
            if (inputsOnPage > 2) {
                setAutoCompleteValue('should-not-autocomplete')
            }
        }

        if (!countyOptions.length) {
            initCountySelectOtions()
        }

        if (!countyOptions.length) {
            initYearOtions()
        }
    }, [])

    return (
        <div className='top-list-header'>
            <div className='top-list-header__search'>
                <div className='top-list-header__header'>
                    <h1>{props.heading}</h1>
                    <div className='top-list-header__image'>
                        <Icon
                            iconName={'cup'}
                            size={60}
                            color={'#ffce44'}
                        />
                    </div>
                </div>
                <div className='top-list-header__select'>
                    <div className='top-list-header__county-select'>
                        <InputSelect
                            id="association-toplist-county-selector"
                            className="association-toplist-county-selector"
                            label={''}
                            allowInput={false}
                            hideLabel={true}
                            onChange={onChangeCounty}
                            value={county}
                            theme={InputSelectTheme.Default}
                            options={countyOptions}
                            placeholder={t('campaign.selectCountyPlaceholder')}
                        />
                    </div>
                    <div className='top-list-header__year-select'>
                        <InputSelect
                            id="association-toplist-year-selector"
                            className="association-toplist-year-selector"
                            label={''}
                            allowInput={false}
                            hideLabel={true}
                            onChange={onChangeYear}
                            value={year}
                            theme={InputSelectTheme.Default}
                            options={yearOptions}
                            placeholder={t('campaign.selectCountyPlaceholder')}
                        />
                    </div>
                </div>
                <InputSearch
                    id="list-search"
                    autoComplete={autoCompleteValue}
                    label=""
                    value={search}
                    onChange={onChangeSearch}
                    placeholder={t('campaign.searchPlaceholder')}
                />
            </div>
        </div>
    )
}
function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[]
}
export default TopListHeader
